import React from 'react';
import PropTypes from 'prop-types';
import { Subhead } from '../../styled components/Typography';
import YPTimesheetLogItemObject from '../../yesplan_classes/YPTimesheetLogItemObject';
import { dateFormatOptions } from '../../libs/dateFormatting';
import { timeFormatOptions } from '../../libs/timeFormatting';
import Timeline from '../../styled components/Timeline.style';
import TimelineItem from '../../components/TimelineItem/TimelineItem';
import { serializeYesplanAPIDateAndTime } from '../../libs/dateTimeUtilities';
import { hashString } from '../../libs/stringHashing';

function TimesheetLog(props) {
  const { logItems, dateFormatSetting, timeFormatSetting } = props;

  const getIconBulletForAction = (actionType) => {
    if (actionType === 'reject') return 'xmark-circle';
    if (actionType === 'approve') return 'seal-checkmark-fill';
    if (actionType === 'finalize') return 'check';
    return null;
  };

  const getIconBulletColorForAction = (actionType) => {
    if (actionType === 'reject') return 'red';
    if (actionType === 'approve' || actionType === 'finalize') return 'blue';
    return false;
  };

  const renderLogItem = (item, showAxis) => {
    const actionType = item.getActionType();
    const description = item.getLogText();
    const dateTime = item.getTimestamp();
    const iconBullet = getIconBulletForAction(actionType);
    const iconBulletColor = getIconBulletColorForAction(actionType);
    const user = item.getUser();

    return (
      <TimelineItem
        key={`${hashString(description)}-${serializeYesplanAPIDateAndTime(dateTime)}`}
        description={description}
        dateTimeObject={dateTime}
        dateFormatSetting={dateFormatSetting}
        timeFormatSetting={timeFormatSetting}
        user={user}
        showTimelineAxe={showAxis}
        iconBullet={iconBullet}
        iconBulletColor={iconBulletColor}
      />
    );
  };

  if (logItems.length === 0) return null;
  return (
    <>
      <Subhead tw="block">{i18n('History')}</Subhead>
      <Timeline tw="mt-8">
        {logItems.map((logItem, index) =>
          renderLogItem(
            logItem,
            index !== logItems.length - 1,
            dateFormatSetting,
            timeFormatSetting
          )
        )}
      </Timeline>
    </>
  );
}

TimesheetLog.propTypes = {
  logItems: PropTypes.arrayOf(PropTypes.instanceOf(YPTimesheetLogItemObject)).isRequired,
  dateFormatSetting: PropTypes.oneOf(dateFormatOptions).isRequired,
  timeFormatSetting: PropTypes.oneOf(timeFormatOptions).isRequired
};

export default TimesheetLog;
